'use strict';

var React = require('react');
var Typography = require('../../DataDisplay/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var AlertMessage = function AlertMessage(_ref) {
  var message = _ref.message;
  return React__default["default"].createElement(Typography, {
    variant: "h6"
  }, message);
};

module.exports = AlertMessage;
